import React, { useState, useEffect } from "react";
import Table from "../../../../core/pagination/datatable";
import { Link } from "react-router-dom";
import { Input, Spin, Select, Drawer, Switch, Modal } from "antd";
import { Edit, Check, X } from "feather-icons-react/build/IconComponents";
import { getApiBaseUrl, LOGIN, ADD_ACTIVITY } from "../../Config/Config";
import Swal from "sweetalert2";

const InspectionChecklistItems = () => {
  const columns = [
    {
      title: "Checklist Name",
      dataIndex: "Text",
      render: (_, record) =>
        editingRow === record.id ? (
          <Input
            value={editForm.Text}
            onChange={(e) =>
              setEditForm((prev) => ({
                ...prev,
                Text: e.target.value,
              }))
            }
          />
        ) : (
          record.Text
        ),
    },
    {
      title: "Display Order",
      dataIndex: "displayOrder",
      render: (_, record) =>
        editingRow === record.id ? (
          <Input.TextArea
            value={editForm.displayOrder}
            autoSize={{ minRows: 1, maxRows: 3 }}
            onChange={(e) =>
              setEditForm((prev) => ({
                ...prev,
                displayOrder: e.target.value,
              }))
            }
          />
        ) : (
          record.displayOrder
        ),
    },
    {
      title: "Actions",
      align: "center",
      render: (_, record) =>
        editingRow === record.id ? (
          <div className="action-table-data">
            <div className="edit-delete-action">
              <Link
                className="me-2 p-2"
                onClick={() => requestReauth("edit", record)}
              >
                <Check className="feather-check" />
              </Link>
              <Link
                className="me-2 p-2"
                onClick={() => {
                  setEditingRow(null);
                  setEditForm({ Text: "", displayOrder: "" });
                }}
              >
                <X className="feather-x" />
              </Link>
            </div>
          </div>
        ) : (
          <div className="action-table-data">
            <div className="edit-delete-action">
              <Link
                className="me-2 p-2"
                onClick={() => {
                  setEditingRow(record.id);
                  setEditForm({
                    Text: record.Text,
                    displayOrder: record.displayOrder,
                  });
                }}
              >
                <Edit className="feather-edit" />
              </Link>

              <Switch
                checked={record.active}
                size="small"
                style={{
                  backgroundColor: record.active ? "#1677ff" : undefined,
                }}
                onChange={(checked) => requestReauth("toggle", { id: record.id, checked })}
              />
            </div>
          </div>
        ),
    },
  ];

  const [data, setData] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [editForm, setEditForm] = useState({
    Text: "",
    displayOrder: "",
  });
  const [saving, setSaving] = useState(false);

  const [loading, setLoading] = useState(false);
  const [checklistLoading, setChecklistLoading] = useState(false);

  const [addForm, setAddForm] = useState({
    Text: "",
    displayOrder: "",
  });
  const [addDrawerOpen, setAddDrawerOpen] = useState(false);
  const [addLoading, setAddLoading] = useState(false);

  const [checklistOptions, setChecklistOptions] = useState([]);
  const [selectedChecklist, setSelectedChecklist] = useState(null);
  const [selectedAddChecklist, setSelectedAddChecklist] = useState(null);

  // Re-auth modal shared state for Edit & Toggle
  const [reauthVisible, setReauthVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [reauthLoading, setReauthLoading] = useState(false);
  const [pendingOperation, setPendingOperation] = useState(null); // { type: "edit"|"toggle", data: any }

  // Inline re-auth for Add (in Drawer)
  const [askPasswordAdd, setAskPasswordAdd] = useState(false);
  const [passwordAdd, setPasswordAdd] = useState("");
  const [showPasswordAdd, setShowPasswordAdd] = useState(false);
  const [errorAdd, setErrorAdd] = useState("");

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");

  // ────────────────────────────────────────────────
  // Audit logging
  // ────────────────────────────────────────────────
  const logActivity = async (isSuccess, notes) => {
    try {
      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: user?.UserID,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: notes,
          Location: "ChecklistItems",
          IsSucces: isSuccess ? 1 : 0,
        }),
      });
    } catch (err) {
      console.error("Failed to log activity:", err);
    }
  };

 
  const fetchChecklists = async () => {
    setChecklistLoading(true);
    try {
      const res = await fetch(`${getApiBaseUrl()}/Checklist/getChecklist`);
      const json = await res.json();
      if (json.Status && json.ResultData?.length > 0) {
        const options = json.ResultData.map((item) => ({
          label: item.ChecklistName,
          value: item.Id,
        }));
        setChecklistOptions(options);
        setSelectedChecklist(options[0]?.value);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setChecklistLoading(false);
    }
  };

  const fetchChecklistItems = async () => {
    if (!selectedChecklist) return;
    setLoading(true);
    try {
      const res = await fetch(
        `${getApiBaseUrl()}/Checklist/getallChecklistItems?ChecklistId=${selectedChecklist}`
      );
      const json = await res.json();
      if (json.Status) {
        setData(
          json.ResultData.map((item) => ({
            key: item.Id,
            id: item.Id,
            Text: item.Text,
            displayOrder: item.displayOrder,
            active: item.IsActive,
          }))
        );
      } else {
        setData([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChecklists();
  }, []);

  useEffect(() => {
    fetchChecklistItems();
  }, [selectedChecklist]);


  const handleAddSubmit = () => {
    if (!selectedAddChecklist || !addForm.Text.trim()) {
      Swal.fire("Warning", "Please select checklist and enter name", "warning");
      return;
    }

    setAskPasswordAdd(true);
    setErrorAdd("");
  };

  const handleAuthAdd = async () => {
    if (!passwordAdd.trim()) {
      setErrorAdd("Please enter your password.");
      return;
    }

    setAddLoading(true);
    setErrorAdd("");

    try {
      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: user?.UserName,
          password: passwordAdd,
        }),
      });

      const data = await res.json();

      if (data.status) {
        setAskPasswordAdd(false);
        setPasswordAdd("");
        await performAdd();
      } else {
        setErrorAdd(data.Message || "Invalid credentials.");
      }
    } catch (err) {
      setErrorAdd("Unable to authenticate.");
    } finally {
      setAddLoading(false);
    }
  };

  const performAdd = async () => {
    const payload = {
      Text: addForm.Text.trim(),
      displayOrder: Number(addForm.displayOrder) || 0,
      CreatedBy: user.UserID || 12,
      ChecklistId: Number(selectedAddChecklist),
    };

    try {
      const res = await fetch(`${getApiBaseUrl()}/Checklist/addChecklistItems`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const json = await res.json();

      if (json?.Status) {
        await logActivity(true, `Checklist item "${payload.Text}" added`);
        Swal.fire("Success", "Item added", "success", { timer: 1500 });
        setAddDrawerOpen(false);
        setTimeout(fetchChecklistItems, 400);
      } else {
        await logActivity(false, `Add failed for "${payload.Text}"`);
        Swal.fire("Error", json?.Message || "Add failed", "error");
      }
    } catch (err) {
      await logActivity(false, `Error adding item "${payload.Text}"`);
      Swal.fire("Error", "Connection error", "error");
    } finally {
      setAddForm({ Text: "", displayOrder: "" });
      setSelectedAddChecklist(null);
      setAskPasswordAdd(false);
      setPasswordAdd("");
      setErrorAdd("");
    }
  };


  const requestReauth = (type, data) => {
    setPendingOperation({ type, data });
    setPassword("");
    setPasswordError("");
    setReauthVisible(true);
  };


  const handleReauthConfirm = async () => {
    if (!password.trim()) {
      setPasswordError("Please enter your password");
      return;
    }

    setReauthLoading(true);
    setPasswordError("");

    try {
      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: user?.UserName,
          password,
        }),
      });

      const data = await res.json();

      if (data.status) {
        setReauthVisible(false);
        setPassword("");
        executePendingOperation();
      } else {
        setPasswordError(data.Message || "Invalid password");
      }
    } catch (err) {
      setPasswordError("Authentication failed. Please try again.");
    } finally {
      setReauthLoading(false);
    }
  };

  const executePendingOperation = () => {
    if (!pendingOperation) return;

    const { type, data } = pendingOperation;

    if (type === "edit") {
      performEdit(data);
    } else if (type === "toggle") {
      performToggle(data.id, data.checked);
    }

    setPendingOperation(null);
  };


  const performEdit = async (record) => {
    const payload = {
      Id: record.id,
      Text: (editForm.Text || "").trim(),
      displayOrder: Number(editForm.displayOrder) || 0,   // Fixed: Use Number() instead of trim for numeric field
      UpdatedBy: user.UserID || 102,
    };

    setSaving(true);
    try {
      const res = await fetch(`${getApiBaseUrl()}/Checklist/updateChecklistItems`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const json = await res.json();

      if (json.Status) {
        await logActivity(true, `Checklist item "${payload.Text}" updated`);
        Swal.fire("Success", "Item updated", "success", { timer: 1400 });
        setData((prev) =>
          prev.map((row) =>
            row.id === record.id
              ? { ...row, Text: payload.Text, displayOrder: payload.displayOrder }
              : row
          )
        );
        setEditingRow(null);
        setEditForm({ Text: "", displayOrder: "" })
         fetchChecklistItems();
      } else {
        await logActivity(false, `Update failed for "${payload.Text}"`);
        Swal.fire("Error", json?.Message || "Update failed", "error");
      }
    } catch (err) {
      await logActivity(false, `Error updating item "${payload.Text}"`);
      Swal.fire("Error", "Connection error", "error");
    } finally {
      setSaving(false);
    }
  };


  const performToggle = async (id, checked) => {
    const payload = {
      Id: id,
      IsActive: checked ? 1 : 0,
      UpdatedBy: user.UserID,
    };

    try {
      const res = await fetch(`${getApiBaseUrl()}/Checklist/deleteChecklistItems`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const json = await res.json();

      if (json.Status) {
        await logActivity(
          true,
          `Checklist item ID ${id} ${checked ? "activated" : "deactivated"}`
        );
        Swal.fire({
          icon: "success",
          title: "Updated",
          text: `Item ${checked ? "activated" : "deactivated"}`,
          timer: 1400,
        });
        fetchChecklistItems();
      } else {
        throw new Error(json?.Message || "Update failed");
      }
    } catch (err) {
      await logActivity(
        false,
        `Failed to ${checked ? "activate" : "deactivate"} item ID ${id}`
      );
      Swal.fire("Error", err.message || "Operation failed", "error");
    }
  };

  return (
    <>
      {(saving || addLoading || reauthLoading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item" aria-current="page">
                    Inspection checklist Items
                  </h4>
                </ol>
              </nav>
              <h6>Manage Checklist Items</h6>
            </div>
            <div className="page-btn">
              <Link
                onClick={() => setAddDrawerOpen(true)}
                className="btn btn-success btn-sm"
              >
                <i className="ti ti-circle-plus fs-4"></i>
              </Link>
            </div>
          </div>

          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set mt-4"></div>
              <Select
                style={{ width: 300 }}
                options={checklistOptions}
                value={selectedChecklist}
                loading={checklistLoading}
                onChange={(value) => setSelectedChecklist(value)}
                placeholder="Select Checklist"
              />
            </div>

            <div className="card-body">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : data?.length > 0 ? (
                  <Table columns={columns} dataSource={data} rowKey="id" />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Add Drawer with inline password */}
        <Drawer
          title="Add Checklist Item"
          placement="right"
          width={420}
          closable={false}
          open={addDrawerOpen}
          onClose={() => {
            setAddDrawerOpen(false);
            setAddForm({ Text: "", displayOrder: "" });
            setSelectedAddChecklist(null);
            setAskPasswordAdd(false);
            setPasswordAdd("");
            setErrorAdd("");
          }}
          extra={
            <div>
              <button
                type="button"
                className="btn btn-sm btn-outline-success me-2"
                title="Save"
                onClick={handleAddSubmit}
                disabled={addLoading}
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                onClick={() => {
                  setAddDrawerOpen(false);
                  setAddForm({ Text: "", displayOrder: "" });
                  setSelectedAddChecklist(null);
                  setAskPasswordAdd(false);
                  setPasswordAdd("");
                  setErrorAdd("");
                }}
              ></button>
            </div>
          }
        >
          <div className="mb-3">
            <label className="form-label">Checklist</label>
            <span className="text-danger ms-1">*</span>
            <Select
              style={{ width: "100%" }}
              options={checklistOptions}
              value={selectedAddChecklist}
              loading={checklistLoading}
              onChange={(value) => setSelectedAddChecklist(value)}
              placeholder="Select Checklist"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">
              Item Name <span className="text-danger ms-1">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="Text"
              placeholder="Enter item name"
              value={addForm.Text}
              onChange={(e) =>
                setAddForm((prev) => ({ ...prev, Text: e.target.value }))
              }
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Display Order</label>
            <input
              className="form-control"
              name="displayOrder"
              placeholder="Enter display order"
              value={addForm.displayOrder}
              onChange={(e) =>
                setAddForm((prev) => ({ ...prev, displayOrder: e.target.value }))
              }
            />
          </div>

          {/* Inline password for Add */}
          {askPasswordAdd && (
            <div className="mt-2">
              <div className="mb-3 w-lg-75 m-auto">
                <label className="form-label">
                  Confirm Password <span className="text-danger"> *</span>
                </label>
                <div className="pass-group">
                  <input
                    type={showPasswordAdd ? "text" : "password"}
                    className="pass-input form-control"
                    value={passwordAdd}
                    onChange={(e) => {
                      setPasswordAdd(e.target.value);
                      setErrorAdd("");
                    }}
                    onCopy={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                    onCut={(e) => e.preventDefault()}
                    placeholder="Enter Password"
                  />
                  <span
                    className={`ti toggle-password ${showPasswordAdd ? "ti-eye" : "ti-eye-off"}`}
                    onClick={() => setShowPasswordAdd(!showPasswordAdd)}
                  ></span>
                </div>
              </div>

              {errorAdd && (
                <div className="alert alert-danger" role="alert">
                  {errorAdd}
                </div>
              )}

              <button
                type="button"
                className="btn btn-primary btn-sm me-2"
                onClick={handleAuthAdd}
                disabled={addLoading || !passwordAdd.trim()}
              >
                {addLoading ? "Verifying..." : "Confirm"}
              </button>
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={() => {
                  setAskPasswordAdd(false);
                  setPasswordAdd("");
                  setErrorAdd("");
                }}
              >
                Cancel
              </button>
            </div>
          )}
        </Drawer>

    
        <Modal
          title="Confirm Password"
          open={reauthVisible}
          onOk={handleReauthConfirm}
          okText="Confirm"
          cancelText="Cancel"
          onCancel={() => {
            setReauthVisible(false);
            setPassword("");
            setPasswordError("");
            setPendingOperation(null);
          }}
          confirmLoading={reauthLoading}
          width={380}
          okButtonProps={{
            disabled: reauthLoading || !password.trim(),
          }}
        >
          <Spin spinning={reauthLoading}>
            <div style={{ marginTop: 16 }}>
              <label className="form-label">
                Password <span className="text-danger">*</span>
              </label>
              <Input.Password
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (passwordError) setPasswordError("");
                }}
                placeholder="Enter your password"
                autoComplete="new-password"
                onCopy={(e) => e.preventDefault()}
                onPaste={(e) => e.preventDefault()}
                onCut={(e) => e.preventDefault()}
                onPressEnter={handleReauthConfirm}
              />
              {passwordError && (
                <div className="text-danger mt-2">{passwordError}</div>
              )}
            </div>
          </Spin>
        </Modal>
      </div>
    </>
  );
};

export default InspectionChecklistItems;

//pagination code for based on api data

// import React, { useState, useEffect } from "react";
// import Table from "../../../../core/pagination/Newdatatable";
// import { Link } from "react-router-dom";
// import { getApiBaseUrl } from "../../Config/Config";
// import { Spin, Select } from "antd";

// const InspectionChecklistItems = () => {
//   const [data, setData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(100);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [loading, setLoading] = useState(false);

//   const getData = async (page = 1, limit = 100) => {
//     setLoading(true);

//     const url = `${getApiBaseUrl()}//api/getFiltersListPg?BlockId=0&Status=0&Barcode=0&pageNumber=${page}&recordslimit=${limit}`;
//     const res = await fetch(url);
//     const json = await res.json();

//     const list = json?.ResultData || [];

//     setData(list);

//     // ✅ READ FROM FIRST RECORD
//     if (list?.length > 0) {
//       setTotalRecords(list[0]?.TotalCount);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     getData(currentPage, pageSize);
//   }, [currentPage, pageSize]);

//   const columns = [
//     {
//       title: "Filter ID",
//       dataIndex: "Lable",
//     },
//     {
//       title: "AHU Code",
//       dataIndex: "AHUcode",
//     },
//   ];

//   return (
//     <>
//       <div className="page-wrapper">
//         <div className="content">
//           <div className="page-header">
//             <div className="page-title">
//               <nav aria-label="breadcrumb">
//                 <ol className="breadcrumb">
//                   <li className="breadcrumb-item">
//                     <Link to="/assetmgt/dashboard">
//                       <i className="fas fa-home fa-lg" />
//                     </Link>
//                   </li>
//                   <h4 className="breadcrumb-item " aria-current="page">
//                     Inspection checklist Items{" "}
//                   </h4>
//                 </ol>
//               </nav>
//               <h6>Manage Checklist Items</h6>
//             </div>
//             <div className="page-btn">
//               <Link
//                 // onClick={() => setAddDrawerOpen(true)}
//                 className="btn btn-success btn-sm"
//               >
//                 <i className="ti ti-circle-plus fs-4"></i>
//               </Link>
//             </div>
//           </div>
//           <div className="card table-list-card">
//             <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
//               <div className="search-set mt-4"></div>
//               <Select
//                 style={{ width: 300 }}
//                 // options={checklistOptions}
//                 // value={selectedChecklist}
//                 // loading={checklistLoading}
//                 // onChange={(value) => setSelectedChecklist(value)}
//                 placeholder="Select Checklist"
//               />
//             </div>
//             <div className="card-body">
//               <div className="table-responsive">
//                 {loading ? (
//                   <div className="text-center my-4">
//                     <Spin size="large" />
//                     <p>Loading data...</p>
//                   </div>
//                 ) : data?.length > 0 ? (
//                   <Table
//                     columns={columns}
//                     dataSource={data}
//                     bordered
//                     stickyHeader
//                     showSlno

//                     currentPage={currentPage}
//                     pageSize={pageSize}
//                     totalRecords={totalRecords}

//                     onPageChange={(page, size) => {
//                       setCurrentPage(page);
//                       setPageSize(size);
//                     }}
//                   />
//                 ) : (
//                   <p className="text-center my-4">No data available</p>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//       </div>
//     </>
//   );
// };

// export default InspectionChecklistItems;
